<template>
  <v-dialog v-model="AddEditdialog" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t(formTitle) }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="valid" class="mt-5">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <label>{{ $t("Name") }}</label>
                <v-text-field
                  v-model="editedItem.en.title"
                  :rules="[
                    validationRules.required,
                    validationRules.maxLength50
                  ]"
                  solo
                  @focus="onFocus()"
                ></v-text-field>
                <div v-if="validation_errors.en.title">
                  <p
                    class="red--text"
                    v-for="(error, index) in validation_errors.en.title"
                    :key="index"
                  >
                    {{ error }}
                  </p>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <div class="form-group">
                  <label>{{ $t("Arabic Name") }}</label>
                  <v-text-field
                    v-model="editedItem.ar.title"
                    solo
                    :rules="[
                      CheckArabicCharactersOnly(editedItem.ar.title),
                      validationRules.maxLength50
                    ]"
                  ></v-text-field>
                  <div v-if="validation_errors.ar.title">
                    <p
                      class="red--text"
                      v-for="(error, index) in validation_errors.ar.title"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <label>{{ $t("Notes") }}</label>
                <v-textarea
                  v-model="editedItem.notes"
                  solo
                  rows="3"
                ></v-textarea>
                <div v-if="validation_errors.notes">
                  <p
                    class="red--text"
                    v-for="(error, index) in validation_errors.notes"
                    :key="index"
                  >
                    {{ error }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn class="modal-btn-cancel" @click="close">{{ $t("Close") }}</v-btn>
        <v-btn
          class="modal-btn-save"
          @click="save"
          :loading="loading"
          :disabled="loading"
          >{{ $t("Save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { validationMixin } from "../../mixins/validationMixin";
export default {
  props: [
    "editedItem",
    "AddEditdialog",
    "formTitle",
    "editedIndex",
    "endPoints"
  ],
  name: "AddEditQualifierComponent",
  mixins: [validationMixin],
  data() {
    return {
      valid: false,
      validation_errors: {
        notes: "",
        en: {
          title: ""
        },
        ar: {
          title: ""
        }
      },
      loading: false
    };
  },
  watch: {
    AddEditdialog: {
      handler() {
        if (this.$refs.form) {
          this.resetValidation();
        }
      }
    }
  },
  methods: {
    close() {
      this.AddEditdialog = false;
      this.editedItem = {};
      this.validation_errors = {
        notes: "",
        en: {
          title: ""
        },
        ar: {
          title: ""
        }
      };
      this.$emit("childToParent", false, null, this.editedIndex);
    },

    save() {
      if (this.valid == false) {
        this.validate();
      } else {
        this.loading = true;
        if (this.editedIndex > -1) {
          axios
            .post(
              this.getApiUrl +
                "/" +
                this.endPoints.edit +
                "/" +
                this.editedItem.id,
              this.editedItem,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token
                }
              }
            )
            .then(response => {
              this.loading = false;
              if (response.data.status.error == true) {
                Object.assign(
                  this.validation_errors,
                  response.data.status.validation_errors
                );
              } else {
                this.AddEditdialog = false;
                this.$emit(
                  "childToParent",
                  false,
                  response.data.data,
                  this.editedIndex
                );
              }
            });
        } else {
          axios
            .post(
              this.getApiUrl + "/" + this.endPoints.create,
              this.editedItem,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.token
                }
              }
            )
            .then(response => {
              if (response.data.status.error == true) {
                Object.assign(
                  this.validation_errors,
                  response.data.status.validation_errors
                );
              } else {
                this.disabledSubmitbtn = true;
                this.editedItem = {
                  notes: "",
                  en: {
                    title: ""
                  },
                  ar: {
                    title: ""
                  }
                };
                this.$emit(
                  "childToParent",
                  false,
                  response.data.data,
                  this.editedIndex
                );
                this.close();
              }

              this.loading = false;
            });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";
.space-name {
  margin-top: -15px !important;
}
</style>
